import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/landing',
    name: 'landing',
    component: () => import('@/views/landing/index.vue'),
    meta: { title: '闪闪亮 口腔护理 — 0元领取口腔健康礼包' }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    name: 'layout',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '仪表盘', keepAlive: true }
      },
      {
        path: 'bill',
        name: 'bill',
        component: () => import('@/views/bill/index.vue'),
        meta: { title: '话单' }
      },
      {
        path: 'ip-whitelist',
        name: 'ipWhitelist',
        component: () => import('@/views/ipWhitelist/index.vue'),
        meta: { title: 'IP白名单' }
      },
      {
        path: 'customer-resource',
        name: 'customerResource',
        component: () => import('@/views/customerResource/index.vue'),
        meta: { title: '客资管理' }
      },
      {
        path: 'oa-punch',
        name: 'oaPunch',
        component: () => import('@/views/oa/punch.vue'),
        meta: { title: '打卡' }
      },
      {
        path: 'oa-leave',
        name: 'oaLeave',
        component: () => import('@/views/oa/leave.vue'),
        meta: { title: '请假' }
      },
      {
        path: 'mine',
        name: 'mine',
        component: () => import('@/views/mine/index.vue'),
        meta: { title: '我的' }
      }
    ]
  }
]

const router = new VueRouter({ routes })

// 登录拦截
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'CRM中继管理'
  if (to.path === '/login' || to.path === '/landing') {
    next()
  } else {
    const token = store.getters['user/token']
    if (token) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
